import { DesignToolMetadata, IntegratedPluginStatus } from "@/lib/api/proposal-api";
import { createSlice } from "@reduxjs/toolkit";

import { fetchDesignToolMetadata } from "./design-tool.actions";

type DesignToolState = {
  syncErrors?: string;
  integratedPluginStatus?: IntegratedPluginStatus;
};

const initialState: Partial<DesignToolMetadata> & DesignToolState = {
  data: undefined,
  tool: undefined,
};

const designToolSlice = createSlice({
  name: "designTool",
  initialState,
  reducers: {
    fetchDesignToolData(state) {},
    setIntegratedPluginStatus(state, action: { payload: IntegratedPluginStatus }) {
      state.integratedPluginStatus = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchDesignToolMetadata.pending, (state, action) => {
        state = {};
      })
      .addCase(fetchDesignToolMetadata.rejected, (state, action: any) => {
        const errorMessage = action.payload?.errors?.message;
        state.syncErrors = errorMessage || action.error.message;
      })
      .addCase(fetchDesignToolMetadata.fulfilled, (state, action: any) => {
        for (const [key, value] of Object.entries(action.payload)) {
          state[key] = value;
        }
      });
  },
});

export const { fetchDesignToolData, setIntegratedPluginStatus } = designToolSlice.actions;

export default designToolSlice;
